import { usePage } from 'hooks/page';
import { usePaginatedQuery } from 'hooks/pagination';
import { useGetPageFilters } from 'hooks/filters';
import { useDeviceType } from 'hooks/device';
import { useGetFilterOptionsQuery, useGetStrollersQuery } from 'services/strollers';

import { Grid } from 'UI';

import StrollerCard from 'components/StrollerCard';
import StrollerCardPlaceholder from 'components/StrollerCard/Placeholder';

import ListBrandFilter from './_modules/ListBrandFilter';
import ListPriceFilter from './_modules/ListPriceFilter';
import ListStarFilter from './_modules/ListStarFilter';
import ListColorFilter from './_modules/ListColorFilter';

const ListStrollers = () => {
	const activeFilters = useGetPageFilters('strollers')
	const { data: strollers, isFetching } = usePaginatedQuery(useGetStrollersQuery, activeFilters);
	const { data: filterOptions } = useGetFilterOptionsQuery();
	const deviceType = useDeviceType();

	const [registerPosition, SEO] = usePage('strollers', {
		filterOptions,
		deviceType,
	}, [
		ListBrandFilter,
		ListPriceFilter,
		ListStarFilter,
		ListColorFilter,
	]);

	return (
		<div className="mt-spacing">
			<SEO>
				<title>Barnvagnsparken</title>
			</SEO>

			<div className="flex gap-x-24 flex-col md:flex-row">
				<div className="md:basis-1/4">
					<h1 className="text-4xl font-semibold">Barnvagnar</h1>

					<div className="mt-10 mb-12 md:mb-0 pb-10 md:pb-0 border-gray-300 border-b md:border-b-0">
						<h3 className="text-2xl font-medium">Filtrering</h3>

						{registerPosition('filters')}
					</div>
				</div>

				<div className="md:basis-3/4">
					{strollers != null && strollers.length == 0 && !isFetching ?
						<div className="text-2xl font-semibold text-center">
							Inga barnvagnar hittades
						</div>
					: null}

					<Grid>
						{strollers != null ?
							strollers.map((stroller) => {
								return (
									<StrollerCard
										key={stroller.strollerId}
										stroller={stroller}
									/>
								);
							})
						: null}

						{isFetching ?
							<>
								<StrollerCardPlaceholder />
								<StrollerCardPlaceholder />
								<StrollerCardPlaceholder />
							</>
						: null}
					</Grid>
				</div>
			</div>
		</div>
	);

};

export default ListStrollers;